import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import AdminContextProvider from "./context/AdminContext.jsx";
import AppContextProvider from "./context/AppContext.jsx";
import { ThemeProvider } from "./context/ThemeContext";
createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <ThemeProvider>
      <AdminContextProvider>
        <AppContextProvider>
          <App />
        </AppContextProvider>
      </AdminContextProvider>
    </ThemeProvider>
  </BrowserRouter>
);
